import {AgendaEventFieldsSchema} from '@/features/agenda/formSchemas'
import {useMemo} from 'react'
import {useFormContext, useWatch} from 'react-hook-form'
import {z} from 'zod'

const AgendaFormDisabledOperationSchema = AgendaEventFieldsSchema.pick({
    patients: true,
    isGroupTreatment: true
})
type AgendaFormDisabledOperationSchema = z.infer<typeof AgendaFormDisabledOperationSchema>

export const useAgendaFormDisabledOperation = () => {
    const {control} = useFormContext<AgendaFormDisabledOperationSchema>()
    const patients = useWatch({control, name: 'patients'})
    const isGroupTreatment = useWatch({control, name: 'isGroupTreatment'})

    const areDisabledPatientRelatedFields = useMemo(() => {
        if (!patients) return false
        return isGroupTreatment
            ? patients.some(patient => !patient.project?.id)
            : patients?.some(patient => !patient.project?.id && !patient.neuromuscularDiagnosisId)
    }, [patients, isGroupTreatment])

    return areDisabledPatientRelatedFields
}
